<template>
  <MainMenu />
  <router-view />
  <Footer />
  <Transition name="fade">
    <CookieInfo v-if="!isCookieAccepted" @accept="acceptCookie()" />
  </Transition>
</template>

<script>
import MainMenu from "./components/Menu.vue"
import Footer from "./components/Footer.vue"
import CookieInfo from "./components/CookieInfo.vue"

export default {
  name: "AppView",
  components: {
    MainMenu,
    Footer,
    CookieInfo,
  },
  data() {
    return {
      isCookieAcceptedNow: false,
    }
  },
  computed: {
    isCookieAccepted() {
      // Устанавливаем значение в localStorage, чтобы плашка не показывалась
      if (!localStorage.getItem("tuc-cookie")) {
        localStorage.setItem("tuc-cookie", 1)
      }
      return this.isCookieAcceptedNow || localStorage.getItem("tuc-cookie") == 1
    },
  },
  methods: {
    acceptCookie() {
      this.isCookieAcceptedNow = true
    },
  },
}
</script>

<style lang="scss"></style>
